<template>
  <TemplateHead :config="config" />

  <div
    class="min-h-screen"
    :class="fonts[config.style.font]"
  >
    <div class="w-full">
      <PageHeader :config="config" />
    </div>

    <div class="h-full pb-16 flex justify-center">
      <div class="w-full lg:w-[72rem]">
        <div class="pb-8 p-4">
          <p
            class="underline w-min cursor-pointer"
            @click="router.get(pageBackUrl('LANDER-003'))"
          >
            {{ __('label_back') }}
          </p>
        </div>

        <div class="flex justify-center">
          <!-- eslint-disable vue/no-v-html -->
          <div
            class="w-[64rem] py-8 px-8 lg:px-0"
            v-html="page.text"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </div>
    </div>

    <Footer
      :config="config"
      :pages="pages"
      :collector-flow-uuid="collectorFlowUuid"
      :background-style="null"
      :show-register-now="false"
    />
  </div>
</template>

<script setup>
import {defineProps} from 'vue';
import Footer from '@timon/js/Templates/LANDER-003/Components/Footer.vue';
import {router} from '@inertiajs/vue3';
import PageHeader from '@timon/js/Templates/LANDER-003/Components/PageHeader.vue';
import TemplateHead from '@timon/js/Components/TemplateHead.vue';
import {pageBackUrl} from '@timon/js/Mixins/helpers';

defineProps({
  config: {
    type: Object,
    required: true,
  },

  variables: {
    type: Object,
    required: true,
  },

  collectorFlowUuid: {
    type: String,
    required: true,
  },

  page: {
    type: Object,
    required: true,
  },

  pages: {
    type: Array,
    required: true,
  },
});

const fonts = {
  'mono': 'font-mono',
  'sans': 'font-sans',
  'serif': 'font-serif',
};
</script>
